export default __webpack_public_path__ + "static/media/CI.ca7ff297.svg";